module.exports = __webpack_public_path__ + "img/AC.3d1c270c.png";